import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Filter } from '../models/filter';
import { ResponseModel } from '../models/response-model';
import { Payment } from '../models/payment';
import { Paging } from '../models/page';
import { ReclasificationRequest } from '../models/request/reclasification-request-model';

@Injectable({
  providedIn: 'root'
})
export class PaymentsService {

  private url = `${environment.url}/payments`;

  constructor(private http: HttpClient) { }


  getPayments(filters: Filter<{ groupingNo: string }>) {
    let params = new HttpParams();
    params = filters.value.groupingNo ? params.append("groupingNo", filters.value.groupingNo) : params;
    return this.http.get<ResponseModel<Paging<Array<Payment>>>>(this.url, { params });
  }

  reclasify(body: ReclasificationRequest) {
    let url = `${environment.url}/payments/reclasify`;

    return this.http.post<ResponseModel<Array<Payment>>>(url, body);
  }

}
